import { createContext, useContext, useState } from 'react';

const CartMenuContext = createContext();

export const CartMenuProvider = ({ children }) => {
    const [isCartOpen, setIsCartOpen] = useState(false);

    return (
        <CartMenuContext.Provider value={{ isCartOpen, setIsCartOpen }}>
            {children}
        </CartMenuContext.Provider>
    );
};

export const useCartMenu = () => useContext(CartMenuContext);
